export var Period;
(function (Period) {
    Period["Today"] = "day";
    Period["Week"] = "week";
    Period["Month"] = "month";
})(Period || (Period = {}));
